module.exports = __webpack_public_path__ + "img/video_info_image.b6009797.png";